<template>
  <ckeditor
    ref="editor"
    :value="value"
    :config="editorConfig"
    :editor-url="editorUrl"
    @input="(v) => $emit('input', v)"
    @ready="onReady"
  ></ckeditor>
</template>

<script>
export default {
  name: 'TextEditor',
  props: {
    value: {
      type: String,
      default: '',
    },
    editorConfig: {
      type: Object,
      default: () => ({
        extraPlugins: ['uploadimage', 'pastefromgdocs'],
        imageUploadUrl: `${process.env.API_URL}admin/media/create`,
        filebrowserUploadUrl: `${process.env.API_URL}admin/media/create`,
        pasteFilter: 'semantic-content',
        pasteFromWordRemoveFontStyles: true,
        pasteFromWordRemoveStyles: true,
        extraAllowedContent: 'iframe[*]{*}(*); blockquote[*]{*}(*); script[*]{*}(*)',
        versionCheck: false,
      }),
    },
  },
  data() {
    return {
      editorUrl: '/js/ckeditor.js',
    }
  },
  methods: {
    /**
     * @param {string} value - Editor HTML content
     * @returns {void}
     */
    onInput(value) {
      this.$emit('input', value)
    },

    /**
     * @param {Object} e - CKEditor instance ready event
     * @returns {void}
     */
    onReady(e) {
      this.$refs.editor.instance.on('fileUploadRequest', (e) => {
        const xhr = e.data.fileLoader.xhr

        const formData = new FormData()
        formData.append('file', e.data.fileLoader.data)
        formData.append('title', e.data.fileLoader.fileName)
        formData.append('resize', 0)

        Object.keys(this.$axios.defaults.headers.common).forEach((key) => {
          xhr.setRequestHeader(key, this.$axios.defaults.headers.common[key])
        })

        xhr.send(formData)
        e.stop()
      })

      this.$refs.editor.instance.on('fileUploadResponse', (e) => {
        e.stop()
        const response = JSON.parse(e.data.fileLoader.xhr.response)
        e.data.url = response.data.original.src
      })
    },
  },
}
</script>
